import React, { useEffect, useState } from "react";
import classNames from "classnames";

import TooltipReact from "../ui/TooltipReact";
import InfoIcon from "../ui/InfoIcon";

function BookingTariffItem({
  tariff,
  isAdditional = false,
  isSelected = null,
  addTariffHandler,
}) {
  const [selected, setSelected] = useState(isSelected);

  useEffect(() => {
    if (isAdditional) {
      setSelected(isSelected ? true : false);
    }
  }, [isSelected]);

  const selectHandler = (e) => {
    e.stopPropagation();
    if (e.target.classList.contains("customRadioCheck")) {
      return;
    }
    addTariffHandler({
      ...tariff,
      active: !selected,
      additional: isAdditional,
    });
    setSelected(!selected);
  };

  return (
    <div
      className={classNames("bookingTariffItem", { active: selected })}
      onClick={selectHandler}
    >
      <div className="bookingTariffItem__title dfsp dfa">
        <div className="dfa">
          <input
            type="checkbox"
            id={`t_${tariff.id}`}
            className="customRadioCheck"
            name="tariff"
            checked={selected}
            onChange={selectHandler}
          />{" "}
          <label htmlFor={`t_${tariff.id}`}></label>
          <span>{tariff.name}</span>
          <span className="i">
            {tariff.description && (
              <TooltipReact id={tariff.id} content={tariff.description}>
                <InfoIcon />
              </TooltipReact>
            )}
          </span>
        </div>
        <div className="bookingTariffItem__price">{tariff.price_sum} ₽</div>
      </div>
      {(tariff.anounce || tariff.description) && (
        <div className="bookingTariffItem__anounce dfsp mob_hide">
          <span>{tariff.anounce}</span>
        </div>
      )}
    </div>
  );
}

export default BookingTariffItem;
